import { h } from 'preact';
import Store from 'store/store';

import ScreeningsByCategory from 'components/shared/theaters/screeningsByCategory';
import s from 'components/shared/theaters/screenings.sss';
import * as svg from 'components/shared/svgIcons/svgIcons';
import { accessNested, asList } from 'utils/utils';
import { replaceWithVNode } from 'utils/vnode';

export default class ScreeningsByFormat extends ScreeningsByCategory {

	constructor(props) {
		super(props);
		// Duplicated code ... (see updateShowtimes.js:RELOAD_FILTERS)
		// Would be better to put that in appData somewhere
		// Formats that should be shown at the top should be at the bottom of the array!
		this.formatOrder = [
			'2d',
			'70mm', '35mm',
			'3d',
			'dolby cinema', 'dolby',
			'imax 2d', '2d imax', 'imax',
			'imax 70mm',
			'imax 3d', '3d imax',
		];
	}

	rewriteRealdFormat(f) {
		let formats = f.split(',').map(e => e.trim().toLowerCase());

		let removedFormats = [];

		let newFormats = formats.filter(f => {
			if (f === '3d' || f === 'reald') {
				removedFormats.push(f);
				return false;
			}
			return true;
		});

		if (!formats.find(f => f.toLowerCase() === 'reald 3d') && removedFormats.length) {
			const indexToReplace = formats.indexOf(removedFormats[0]);
			newFormats.splice(indexToReplace, 0, 'REALD 3D');
		}

		return newFormats.join(', ');
	}

	renderSetup() {
		const pageData = this.props.pageData;
		this.formatSeparator = pageData.movieNameFormatSeparator || ' : ';

		this.hiddenFormatNames = asList(pageData.hiddenFormatNames).map(format => format.toLowerCase().replace(/\s/g, ''));

		let altNames = pageData.alternativeFormatNames || {};
		this.alternativeNames = Object.keys(altNames).reduce((obj, key) => {
			if (key && altNames[key]) {
				obj[key.toLowerCase()] = altNames[key];
			}
			return obj;
		}, {});
	}

	getLookup(screenings) {
		const groups = {};
		const defaultFormat = { label : '2d' };

		const isRealdTheater = accessNested(this.props, 'theater.masterDoc.reald');
		const useTitleFilter = accessNested(this.props, 'appData.options.useTitleFilter');

		screenings.forEach(sc => {
			let title = sc.movie.title;
			let format = (sc.movie.format || defaultFormat).label;
			if (isRealdTheater) format = this.rewriteRealdFormat(format);
			let id = [useTitleFilter && title, format].filter(e => e).join('»»»');
			if (!groups[id]) {
				groups[id] = {
					name: id,
					format,
					movie: title,
					screenings: []
				};
			}
			groups[id].screenings.push(sc);
		});

		const formatOrder = this.formatOrder;
		return Object.values(groups).sort((a, b) => {
			let priority = formatOrder.indexOf(b.format.toLowerCase()) - formatOrder.indexOf(a.format.toLowerCase());
			return priority || a.format.localeCompare(b.format);
		});
	}

	getFormatWithIcon(format) {
		let result = format;
		const lowF = format.toLowerCase();
		// let realD3d = lowF.indexOf('imax') === -1 && lowF.match(/(reald\s*)?\b3d\b/i);
		let realD3d = lowF.match(/\breald\s*3d\b/);
		let fourDX = lowF.match(/\b4dx\b/);
		let atmos = lowF.match('\batmos\b');
		let avx = lowF.match('\bavx\b');
		const exhibitor = accessNested(this.props, 'theater.exhibitor.domain');

		const appData = this.props.appData;
		const shade = appData.styling.formatLogoShade || appData.styling.logoShade;

		// Quickfix to hide the reald logo for empire.
		// TODO: remove
		if (exhibitor === 'empirecinemas.co.uk') {
			realD3d = false;
		}

		if (lowF === 'imax 3d' || lowF === '3d imax') {
			const SvgElem = svg.SvgImax3d;
			result = <SvgElem class={s.imax3dIcon} />;

		} else if (/\bimax\b/.test(lowF)) {
			const imaxName = format.replace(/\b(2d\s+)?(imax)(\s+2d)?\b/i, '$2');
			const SvgElem = svg.SvgImax;
			const imaxIndex = imaxName.match(/\b(imax)\b/i);

			result = [
				imaxName.slice(0, imaxIndex.index),
				<SvgElem class={s.imaxIcon} />,
				imaxName.slice(imaxIndex.index + imaxIndex[0].length)
			];

		} else if (lowF === 'dolby cinema' && exhibitor === 'amctheatres.com') {
			const icon = appData.urls.roots.sharedImages + '/logos/formats/' + shade + '/dolby_amc.png';

			result = <img class={s.amcDolbyIcon} src={icon} />;

		} else if (realD3d) {
			const SvgElem = svg.SvgRealD;

			result = [
				format.slice(0, realD3d.index),
				<SvgElem class={s.realDIcon} />,
				format.slice(realD3d.index + realD3d[0].length)
			];
		} else if (fourDX) {
			const SvgElem = svg.Svg4dx;
			result = <SvgElem class={s.Svg4dx} />;
		} else if (atmos) {
			const SvgElem = svg.SvgAtmos;
			result = <SvgElem class={s.SvgAtmos} />;
		} else if (avx) {
			const SvgElem = svg.SvgAvx;
			result = <SvgElem class={s.SvgAvx} />;
		}

		const dboxIcon = appData.urls.roots.sharedImages + '/logos/formats/' + shade + '/d-box.png';
		result = replaceWithVNode(result, /\bd-?box\b/i, <img class={s.dboxIcon} src={dboxIcon} />);

		const customFormats = accessNested(Store.get(), 'activePage.data.customFormats') || {};

		Object.values(customFormats).forEach(item => {
			if (item.format === result) {
				result = <span class={s.customFormat}>{result}</span>;
			}
		});

		return result;
	}

	getCategoryName(category, catIndex) {
		const lowF = category.format.toLowerCase();
		let content;

		if (category.screenings.length > 0) {
			const props = this.props;

			const copy = props.appData.copy;
			let pageData = props.pageData || {};
			let title = copy.$TITLE_OVERRIDE || copy.$TITLE;

			let noTitleInList = pageData.noTitleInList;
			if (noTitleInList && typeof noTitleInList === 'object') {
				const catCaps = category.format.toUpperCase();
				noTitleInList = Object.keys(noTitleInList).map(title => title.toUpperCase());
				noTitleInList = noTitleInList.indexOf(catCaps) > -1;
			}

			if (noTitleInList) {
				title = '';
			}

			let correctName = category.format;
			if (typeof this.alternativeNames[lowF] === 'string') {
				correctName = this.alternativeNames[lowF];
			}

			let formatsCount = props.filters.format.options.length;
			// Hide the format if it's 2d and the only format
			let hideFormat = formatsCount === 1 && lowF === '2d';
			if (this.hiddenFormatNames.indexOf(lowF) !== -1) {
				hideFormat = true;
			}
			const useTitleFilter = accessNested(this.props, 'appData.options.useTitleFilter');
			const hideMovieName = accessNested(this.props, 'appData.options.hideMovieName');
			content = [
				(!useTitleFilter || !hideMovieName) && title,
				useTitleFilter && category.movie
			];
			if (!hideFormat) {
				content.push(this.getFormatWithIcon(correctName));
			}
			// Add separators
			content = content.filter(e => e).reduce((a, v) => a.concat(this.formatSeparator, v), []);
			// Flatten
			content = [].concat(...content.slice(1));
		}

		const descriptions = this.props.pageData.formatDescriptions || {};
		if (descriptions[lowF]) {
			let desc = descriptions[lowF];
			// nl2br
			desc = desc.split('\n').reduce((a,e,i) => a.concat(i ? [<br />, e] : e), []);
			content = [].concat(content, <div class={s.description}>{desc}</div>);
		}

		if (!content) {
			return;
		}

		return <div class={s.screeningMovie}>{content}</div>;
	}

}
